<template>
  <div
    class="modal fade"
    :ref="`modal-apartment-type-img`"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            {{
              $t(
                apartmentImg.id === 0 ? "common.addNewImg" : "common.imgDetail"
              )
            }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("banner.image")
                }}</label>
                <div>
                  <img
                    id="apartment-img-id"
                    class="asset-img-class img-responsive"
                    :src="
                      apartmentImg.imgUrl !== null && apartmentImg.imgUrl !== ''
                        ? apartmentImg.imgUrl
                        : noImgDefault
                    "
                    alt="asset-img"
                    @click="onOpenInputSelectFile"
                  />
                  <div style="padding-top: 6px; text-align: center">
                    <input
                      :id="`upload-apartment-img${apartmentImg.imgIndex}`"
                      type="file"
                      accept="image/*"
                      @change="onSelectAssetImg"
                    />
                    <p>
                      <small>{{ $t("banner.clickImageToAddOrUpdate") }}</small>
                    </p>
                    <span
                      v-if="
                        apartmentImg.imgUrl !== null &&
                          apartmentImg.imgUrl !== ''
                      "
                      class="remove-asset-img"
                      @click="onClickRemoveApartmentImg"
                      >{{ $t("common.delete") }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">{{ $t("apartmentGroup.description") }}</label>
                <textarea
                  class="form-control"
                  name=""
                  id=""
                  cols="30"
                  rows="4"
                  v-model="apartmentImg.description"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            style="background-color: #f29911;border-color: #f29911;color:#fff"
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >
            {{ $t("common.back") }}
          </button>
          <button type="button" class="btn btn-primary" @click="onSave">
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>
<script>
import configuration from "@/lib/config";
import utils, { uploadFileToMediaAgent } from "@/lib/utils";
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";

export default {
  components: {
    "lte-core-alert": LTECoreAlert
  },
  data: () => ({
    apartmentImg: {
      id: 0,
      imgUrl: null,
      description: null,
      imgIndex: null
    },
    assetImgFileSize: null,
    assetImgFile: null,
    noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
  }),
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    onOpenInputSelectFile: function() {
      $(`#upload-apartment-img${this.apartmentImg.imgIndex}`).click();
    },
    onShowAddNew: function(imgIndex) {
      $(this.$refs[`modal-apartment-type-img`]).modal("show");
      this.apartmentImg = {
        id: 0,
        imgUrl: null,
        description: null,
        imgIndex: imgIndex
      };
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-apartment-type-img`]).modal("show");
      this.apartmentImg = {
        id: data.id,
        imgUrl: data.imgUrl,
        description: data.description,
        imgIndex: data.imgIndex
      };
    },
    onCloseModal: function() {
      $(this.$refs[`modal-apartment-type-img`]).modal("hide");
    },
    onSave: async function() {
      if (utils.isEmptyString(this.apartmentImg.imgUrl)) {
        this.ON_SHOW_TOAST({
          message: this.$t("banner.image"),
          styleType: "danger"
        });
      } else {
        if (!utils.isEmptyString(this.assetImgFileSize)) {
          await this.uploadAssetImg();
        }
        let data = {
          id: this.apartmentImg.id,
          imgUrl: this.apartmentImg.imgUrl,
          description: this.apartmentImg.description,
          index: this.apartmentImg.imgIndex
        };
        this.$emit("apartmentTypeImgEmit", data);
      }
    },
    // img function
    /**
     * Select issuance img
     */
    onSelectAssetImg: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.assetImgFileSize = files[0].size;
      this.apartmentImg.imgUrl = URL.createObjectURL(files[0]);
    },
    /**
     * Get result file
     */
    getResultFile: function(file) {
      let vm = this;
      vm.assetImgFile = file;
    },
    onClickRemoveApartmentImg: function() {
      let inputForm = $(`#upload-apartment-img${this.apartmentImg.imgIndex}`);
      inputForm.val("");
      this.assetImgFile = null;
      this.assetImgFileSize = null;
      this.apartmentImg.imgUrl = null;
    },
    uploadAssetImg: async function() {
      if (this.assetImgFileSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        this.apartmentImg.imgUrl = await uploadFileToMediaAgent(this.assetImgFile, "apartmentImg")
      }
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST",
      // "CREATE_APARTMENT_IMG",
      // "UPDATE_APARTMENT_IMG"
    ])
  },
  mounted() {}
};
</script>
<style scoped>
label.required:not(:empty):after,
.field-header.required:after {
  content: " *";
  color: red;
  position: absolute;
  right: 5px;
  top: 0px;
}
input[type="file"] {
  display: none;
}
.asset-img-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 250px;
  object-fit: contain;
}
.label-text-center {
  padding-bottom: 10px;
}
.remove-asset-img {
  color: #ef5350;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentType/ApartmentTypeImg.vue